import React, { useState } from "react";
import { Navbar, Footer, Sidebar } from '../adminComponents';

const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
      <div className="flex-grow-1">
        <Navbar toggleSidebar={toggleSidebar} />
        <div className="container mt-3" style={{ marginTop: "70px", padding: "15px" }}>
          {children}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;